import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { offerAgreementsAPI } from "api/api/offerAgreementsApi/offerAgreementsApi";
import { CreateMarathonAgreementsByMarathonIdBody, CreateMarathonAgreementsByMarathonIdRes } from "api/api/offerAgreementsApi/types";

export const createMarathonAgreementsByMarathonId = createAsyncThunk<
  CreateMarathonAgreementsByMarathonIdRes,
  CreateMarathonAgreementsByMarathonIdBody
>("statuses/createMarathonAgreementsByMarathonId", async (body, { rejectWithValue }) => {
  try {
    const data = await offerAgreementsAPI.createMarathonAgreementsByMarathonId(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while creating marathon agreements", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while creating marathon agreements", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
